import DataStore from '@/engine/stores/data-store';

class ProjectDataStore extends DataStore {
}

export default new ProjectDataStore();
